import { Route, Routes } from "react-router-dom";
import Challenges from "./Challenges";

export default function ChallengesRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Challenges />} />
    </Routes>
  );
}